export default __webpack_public_path__ + "static/model-agnostic-bc6a1ab435c0418b15866a22e603ffe7.png";